import PropTypes from 'prop-types';

export function Button({
  title,
  onClick,
  className = '',
  disabled = false,
  ariaLabel,
  type = 'button',
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`flex w-full items-center justify-center rounded-components-button-global-borderradius bg-primary-primary-50 px-4 py-2 transition-all duration-200 hover:bg-primary-primary-40 focus:outline-none focus:ring-2 focus:ring-primary-primary-40 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 sm:px-6 md:px-9 ${className}`}
      onClick={onClick}
      aria-label={ariaLabel || title}
    >
      <div className="flex h-components-button-global-controlheightlg items-center justify-center gap-components-button-global-marginxs">
        <span className="text-left font-button-button-1-font-family text-button-button-1-font-size font-button-button-1-font-weight uppercase leading-button-button-1-line-height text-neutral-neutral-00">
          {title}
        </span>
      </div>
    </button>
  );
}

Button.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
};
